import { css } from '@emotion/react'

const header = css`
  font-family: 'Merriweather', serif;
  font-weight: 700;
  margin: 24px 0;
  letter-spacing: 0;
  font-variant-numeric: lining-nums;
`

const h1 = css`
  ${header}
  font-size: 48px;
  line-height: 57.6px;
`

const h2 = css`
  ${header}
  font-size: 36px;
  font-weight: 700;
  line-height: 43.2px;
`

const h3 = css`
  ${header}
  font-size: 24px;
  line-height: 28.8px;
`

const h4 = css`
  ${header}
  font-size: 18px;
  line-height: 21.6px;
`

const body = css`
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 34px;
  margin: 12px 0;
  letter-spacing: 0;
`
const strong = css`
  ${body}
  font-weight: 600;
`

const metric = css`
  font-family: 'Fira Code', monospace;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.6px;
`
const quote = css`
  font-family: 'Merriweather', serif;
  font-size: 28px;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: 0;
`

const freeTextBlock = css`
  & * {
    margin: 0;
  }
  & ol,
  & ul {
    ${body};
    margin: 0;
  }
  & p {
    ${body};
  }
  & strong {
    ${strong};
  }
  & h1 {
    ${h1};
  }
  & h2 {
    ${h2};
  }
  & h3 {
    ${h3};
  }
  & h4 {
    ${h4};
  }
`

export const storyTypography = {
  h1,
  h2,
  h3,
  h4,
  body,
  strong,
  metric,
  quote,
  freeTextBlock,
}
